<template>
  <div>
    <v-btn
      :to="{ name: 'account.login' }"
      v-if="!loggedIn"
      color="primary"
      :disabled="authLoading"
      :loading="authLoading"
    >
      <v-icon class="mr-2">mdi-login</v-icon>
      {{ $t("login.title") }}
    </v-btn>
    <v-menu offset-y v-else-if="authUser">
      <template v-slot:activator="{ on }">
        <v-btn :disabled="authLoading" :loading="authLoading" color="primary" v-on="on">
          <v-icon>mdi-account</v-icon>
          <span class="d-none d-sm-inline">
            {{ authUser.name }}
          </span>
          <span class="d-sm-none">
            {{ authUser.name | limit(10) }}
          </span>
          <template v-if="selectedTenant">
            |
            <v-icon>mdi-office-building-marker</v-icon>
            <span class="d-none d-sm-inline">
              {{ selectedTenant.name | limit(20) }}
            </span>
            <span class="d-sm-none">
              {{ selectedTenant.name | limit(10) }}
            </span>
          </template>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item :to="{ name: 'account.profile' }">
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("nav.profile") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'account.tenant' }">
          <v-list-item-icon>
            <v-icon>mdi-office-building-marker</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("nav.tenant") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'account.sessions' }">
          <v-list-item-icon>
            <v-icon>mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("nav.sessions") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="doLogout">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t("nav.logout") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script lang="ts">
import AuthStateMixin from "@/mixins/store/AuthStateMixin";
import Component, { mixins } from "vue-class-component";
import TenantStateMixin from "@/mixins/store/TenantStateMixin";

@Component
export default class LoginBar extends mixins(AuthStateMixin, TenantStateMixin) {
  doLogout(): void {
    this.authLogout().then(() => {
      if (this.$route.name === "home") {
        this.$router.go(0);
      } else {
        this.$router.push({ name: "home" });
      }
    });
  }
}
</script>
<style type="scss">
.custom-loader {
  animation: loader 0.75s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
